import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-voucher-footer',
   imports: [CommonModule, RouterModule],
  templateUrl: './voucher-footer.component.html',
  styleUrl: './voucher-footer.component.css'
})
export class VoucherFooterComponent {

  showFooter = true;

  constructor(
    private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;

        if (url === '/' || url === '') {
          this.showFooter = true;
        } else if (url === '/voucher-setup' || url.includes('/login') || url.includes('/verify-otp')) {
          this.showFooter = false;
        } else {
          this.showFooter = true;
        }
      }
    });
  }
}
